import React from "react";
import { useTranslation } from "react-i18next";

import logo from "img/FS_logotipo_beta_branco.png";

function App() {
  const { t } = useTranslation();

  return (
    <div style={{ display: "flex", marginTop: "6em" }}>
      <div style={{ margin: "auto" }}>
        <div>
          <img
            src={logo}
            alt=""
            style={{ margin: "auto", display: "block", marginBottom: "2em", maxWidth: "25%" }}
          />
        </div>

        <p>
          {t("SUCCESS_account_created")}
          <a href="/">aqui.</a>
          <br />
          <br />
          <br />
          {t("SUCCESS_account_created_reseted")}
          <a href="/recuperar-password">aqui.</a>
        </p>
      </div>
    </div>
  );
}

export default App;
